import { create } from 'zustand';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';

export interface Props {
  platform: ALL_SOCIAL_PLATFORM_TYPE | undefined;
  setPlatform: (platform: Props['platform']) => void;

  creatorId: string;
  setCreatorId: (creatorId: Props['creatorId']) => void;

  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

export const useRemovePlatformStore = create<Props>((set) => ({
  platform: undefined,
  creatorId: '',
  setPlatform: (platform) => set(() => ({ platform })),
  setCreatorId: (creatorId) => set(() => ({ creatorId })),
  isModalOpen: false,
  setIsModalOpen: (isOpen) => {
    if (isOpen) return set({ isModalOpen: true });

    return set(() => ({
      isModalOpen: false,
      platform: undefined,
      creatorId: '',
    }));
  },
}));
